import React from 'react';
import { CardView, rem } from 'design-system';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import QuestsProgressIcon from './QuestsProgressIcon';
const QuestsHeader = ({ percentage }) => {
    const styles = useStyles(styleSet);
    return (<CardView style={styles.container}>
      <QuestsProgressIcon width={rem(64)} height={rem(64)} style={styles.icon}/>
      <Text Text-16 centered OffBlack>
        You have completed {percentage}% of all quests.
      </Text>
    </CardView>);
};
const styleSet = createStyleSheets(() => ({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
        padding: rem(16),
        paddingHorizontal: rem(56),
        overflow: 'visible',
        marginBottom: rem(8),
    },
    icon: {
        marginBottom: rem(24),
    },
}));
export default QuestsHeader;
